import { useEffect, useState } from "react";
import { isAuthenticated } from "../../services/AuthService";
export default function MainNav() {
  const [isAuth, setIsAuth] = useState(false);
  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = await isAuthenticated();
      setIsAuth(Boolean(currentUser));
    };
    checkAuth();
  });
  return isAuth ? (
    <div className="main-nav">
      <nav className="speeches lg:col-start-2 lg:col-span-3 lg:space-x-4">
        <a href="/">Home</a>
      </nav>
      <nav className="user lg:col-start-10 justify-end">
        <a href="/profile">Profilo</a>
      </nav>
      <nav className="user lg:col-start-11 justify-end">
        <a
          href="#"
          onClick={(evt) => {
            evt.preventDefault();
            localStorage.removeItem("user");
            window.location.href = "/";
          }}
        >
          Logout
        </a>
      </nav>
    </div>
  ) : null;
}
